import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Image } from 'primereact/image';

import { CertificatesTab } from '../CertificatesTab';
import { formatDate } from '../../../appconfig/AppHelper';
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { defaultPageRowOptions, defaultRowOptions, IMAGE_BASEURL, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { CertificateShowClick } from '../../../config/Validate';
import { DOWNLOAD_ORIGINAL_CERTIFICATE, ORIGINAL_CERTIFICATE_LIST, SAVE_ORIGINAL_CERTIFICATE } from '../../../config/ApiConstant';
import { OriginalListShowColumns } from '../../../appconfig/DatatableSetting';
import { RegDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import Loader from '../../../components/Loadeer/Loader';

export const OriginalCertificate = () => {
    document.title = 'Original Certificate | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [certificateList, setCertificateList] = useState<any>([]);
    const [regNo, setRegNo] = useState<any>(null);
    const [certificateData, setCertificateData] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [saveLoader, setSaveLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setCertificateData({});
        setCertificateList([]);
        setErrors({});
    };

    // On show click
    const onShowClick = async () => {
        try {
            const { errors, isError } = CertificateShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                setPageLoad(false);

                const response = await getAllDetailsDirect(ORIGINAL_CERTIFICATE_LIST + '?RegNo=' + regNo);
                if (window.cn(response.details)) {
                    setShowLoading(false);
                    setPageLoad(false);
                    toast.current?.show({ severity: 'error', summary: 'Message', detail: 'Registration Number Is Wrong!' });
                } else {
                    if (!window.cn(response.details) && !window.cn(response.details[0])) {
                        setShowLoading(false);
                        setPageLoad(true);
                        setCertificateData(response.details[0]);
                        if (response.details.length > 0) {
                            setCertificateList(response.details);
                        }
                    }
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    // Template for issue date
    const IssueDateTemplate = (rowData: any, rowIndex: any) => {
        return <>{!window.cn(rowData.OrgIDt) ? formatDate(rowData.OrgIDt) : ''}</>;
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" tooltip="Download" tooltipOptions={{ position: 'top' }} className="p-button-primary" onClick={() => downloadCertificate(rowData.EntryNo)} loading={showLoading} />
                </div>
            </>
        );
    };

    // Download certificate
    const downloadCertificate = async (SrNo: any) => {
        try {
            setLoading(true);
            const response = await getAllDetails(DOWNLOAD_ORIGINAL_CERTIFICATE + '/' + SrNo);
            if (response) {
                //PDF Download
                const fileName = `Original-Certificate-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = response.file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setLoading(false);
            } else {
                setLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        } catch (error: any) {
            if (error.response) {
                setLoading(false);

                //Spinner False and Set Toast
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Save Original certificate
    const saveOriginalCertificate = async () => {
        try {
            setSaveLoader(true);

            let formData: any = new FormData();
            formData.append('regNo', regNo);

            const response = await postAllData(SAVE_ORIGINAL_CERTIFICATE, formData);
            if (response) {
                setSaveLoader(false);
                onShowClick();
                toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSaveLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
             <CertificatesTab  mainTabLabel="Original Certificate" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Reg No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Show" className="p-button-primary" onClick={() => onShowClick()} loading={showLoading} />
                            </div>
                            <div className="field col-12 md:col-3"></div>
                            <div className="field col-12 md:col-2 mb-0">
                                <Button label="Remaining Certificate List" className="p-button-secondary p-button-outlined" onClick={() => navigate('/app/certificate/remaining-original-certificate-list')} />
                            </div>

                            <div className="field col-12 md:col-2 mb-0">
                                <Button label="Original Certificate List" className="p-button-primary p-button-outlined ml-2" onClick={() => navigate('/app/certificate/original-certificate-list')} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-2">
                                {!window.cn(certificateData?.Image) ? (
                                    <Image src={certificateData?.Image} alt="Image" width="150" preview style={{ border: '1px solid #333' }} />
                                ) : (
                                    <Image src={IMAGE_BASEURL + 'no-image.jpg'} alt="Image" width="150" />
                                )}
                            </div>
                            <div className="field col-12 md:col-10">
                                <div className="p-fluid formgrid grid">
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="Name">Name</label>
                                        <InputText value={!window.cn(certificateData?.Name) ? certificateData?.Name : ''} name="Name" disabled={true} />
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="DegNm">Degree</label>
                                        <InputText value={!window.cn(certificateData?.DegNm) ? certificateData?.DegNm : ''} name="DegNm" disabled={true} />
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="BOD">Birth Date</label>
                                        <InputText value={!window.cn(certificateData?.BOD) ? formatDate(certificateData?.BOD) : ''} name="BOD" disabled={true} />
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="RegDt">Reg Date</label>
                                        <InputText value={!window.cn(certificateData?.RegDt) ? formatDate(certificateData?.RegDt) : ''} name="RegDt" disabled={true} />
                                    </div>
                                    <div className="field col-12 md:col-4">
                                        <label htmlFor="LastVDate">Valid Upto</label>
                                        <InputText value={!window.cn(certificateData?.LastVDate) ? formatDate(certificateData?.LastVDate) : ''} name="LastVDate" disabled={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => saveOriginalCertificate()} loading={saveLoader} disabled={!window.cn(certificateData) && !window.cn(certificateList) ? false : true} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                    removableSort
                                >
                                    {OriginalListShowColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegDtTemplate} />;
                                        } else if (col.field === 'OrgIDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={IssueDateTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {OriginalListShowColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading && <Loader />}
        </>
    );
};
